module.exports = __webpack_public_path__ + "static/media/Screenshot_3.a04b97c3.png";